import React from 'react'

import { useGetWorkspaceQuery } from '@sketch/gql-types'
import { RouteParams, routes } from '@sketch/modules-common'
import { Redirect, useParams } from 'react-router'

/**
 * Redirect from the root of the current workspace (/workspace/:workspaceId)
 * to the workspace shares page or the workspace settings page depending
 * on the user role.
 */
export function WorkspaceRootRedirect() {
  const { workspaceId } = useParams<RouteParams<'WORKSPACE'>>()
  const { data: workspaceData, loading } = useGetWorkspaceQuery({
    variables: { identifier: workspaceId },
  })

  const userRole = workspaceData?.workspace.userRole

  if (loading) {
    return null
  }

  if (userRole === 'FINANCE' || userRole === 'PARTNER') {
    return (
      <Redirect
        to={routes.WORKSPACE_SETTINGS_PEOPLE.create({
          workspaceId,
        })}
      />
    )
  }

  return (
    <Redirect
      to={routes.WORKSPACE_SHARES.create({
        workspaceId,
      })}
    />
  )
}
